<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="用户发票详情"> </el-page-header>
    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="用户名称" class="detail-form-item">
                  <el-input size="medium" v-model="entity.user.realName" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="发票类型" class="detail-form-item">
                  <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                    <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="单位名称" class="detail-form-item">
                  <el-input size="medium" v-model="entity.companyName"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="是否默认" class="detail-form-item">
                  <el-radio-group v-model="entity.default">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="纳税人识别号" class="detail-form-item">
                  <el-input size="medium" v-model="entity.taxpayerId"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="注册地址" class="detail-form-item">
                  <el-input size="medium" v-model="entity.address"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="开票电话" class="detail-form-item">
                  <el-input size="medium" v-model="entity.phone"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="开户银行" class="detail-form-item">
                  <el-input size="medium" v-model="entity.bank"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="银行账号" class="detail-form-item">
                  <el-input size="medium" v-model="entity.bankAccount"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Invoice } from "@/script/apps/user/entity/UserEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { InvoiceService } from "@/script/apps/user/service/InvoiceService";
import { ElMessage } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";

@Options({})
export default class InvoiceDetail extends BaseDetail {
  private service = new InvoiceService();

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_user_invoice",
      "/user/invoice",
      "/user/invoice",
      this.service
    );
    data.entity = { user: { realName: "" } };
    data.typesName = "uc-invoice-type";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Invoice = {};
    return entity;
  }
}
</script>

<style lang="scss">
</style>
